// extracted by mini-css-extract-plugin
module.exports = {"logo":"HomeButton_logo__8UzK9"};